import * as managejobapi from "app/services/recruiterapi/ManageJobAPI";

export const MAANAGEJOBDETAILS_ERROR = "MAANAGEJOBDETAILS_ERROR";
export const MAANAGEJOBDETAILS_SUCCESS = "MAANAGEJOBDETAILS_SUCCESS";

// Manage job Details
// export function managejobDetailsActions(formData) {
// 	console.log("Action data",formData)
// 	return dispatch =>
// 	managejobapi.managejobDetailsAPI(formData)

// 			.then(response => {
// 				console.log("managereducer", response)

// 				return dispatch({
// 					type: MAANAGEJOBDETAILS_SUCCESS,
// 					payload: response
// 				})

// 			})
// 			.catch(error => {
// 				console.log("manageerrorreducer", error)
// 				return dispatch({
// 					type: MAANAGEJOBDETAILS_ERROR,
// 					payload: error
// 				})

// 			});
// }

//search
export function managejobSearchActions(data, res) {
  managejobapi.managejobSearchAPI(data, (response) => {
    if (response.token) {
      managejobapi.managejobSearchAPI(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}

// Candidate List
export function managejobListActions(data, res) {
  managejobapi.managejoblistAPI(data, (response) => {
    if (response.token) {
      managejobapi.managejoblistAPI(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}

export function managejobDetailsActions(data, res) {
  managejobapi.managejobDetailsAPI(data, (response) => {
    if (response.token) {
      managejobapi.managejobDetailsAPI(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}

// job Status whole list
export function manageJobStatusListActions(data, res) {
  managejobapi.getJobStatusList(data, (response) => {
    if (response.token) {
      managejobapi.getJobStatusList(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}

//post Job on Dice Action Pow-128.October 7 2022 Ayush... Code Starts//
export function postJobOnDiceAction(data, res) {
  managejobapi.postJobOnDice(data, (response) => {
    if (response.token) {
      managejobapi.postJobOnDice(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}

//post Job on Dice Action Pow-128. October Code End//

//get dashboard data pow-99 starts
export function manageDashboardDataAction(data, res) {
  managejobapi.getDashboardData(data, (response) => {
    if (response.token) {
      managejobapi.getDashboardData(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}
//get dashboard data pow-99 ends//

//get all job unattended action pow-99 starts
export function manageJobUnattendedAction(data, res) {
  managejobapi.getAllJobUnattended(data, (response) => {
    if (response.token) {
      managejobapi.getAllJobUnattended(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}
//get all job unattended action pow-99 starts

//get all jobs client totals action POW_99 starts

export function manageAllJobClientsTotalAction(data, res) {
  managejobapi.getAllJobsClientsTotal(data, (response) => {
    if (response.token) {
      managejobapi.getAllJobsClientsTotal(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}

//get all jobs client totals action POW_99 ends

//get Recruiters Submission Action POW-99 starts

export function manageRecruiterSubmissionsAction(data, res) {
  managejobapi.getRecruiterSubmissions(data, (response) => {
    if (response.token) {
      managejobapi.getRecruiterSubmissions(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}

//get Recruiters Submission Action POW-99 ends

//get assigned recruiters Jobs Ation POW-99 starts

export function manageAssignedRecruitersJobsAction(data, res) {
  managejobapi.getAssignedRecruitersJobs(data, (response) => {
    if (response.token) {
      managejobapi.getAssignedRecruitersJobs(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}

//get assigned recruiters Jobs Ation POW-99 starts

/* Added this code for  POW-486. Dharmateja. February 24 2023.. Code Start */
export function manageCandidateStatusActions(data, res) {
	managejobapi.manageCandidateStatusAPI(data, (response) => {
		if (response.token) {
			managejobapi.manageCandidateStatusAPI(data, (response) => {
				return res(response)
			})
		}
		else {
			return res(response)
		}
	})
}
/* Dharmateja. February 24 2023.. Code End */

/***** Added code for Task:POW-668   *(Dharma Teja - 16-07-2025) *****/
export function manageJobAssign(data, res) {
  managejobapi.manageJobAssignAPI(data, (response) => {
    if (response.token) {
      managejobapi.managejobSearchAPI(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}
/***** Completed code for Task:POW-668   *(Dharma Teja - 16-07-2025) *****/

// Check submit status
export function checkSubmitStatusAction(candid, res) {
  managejobapi.checkSubmitStatusAPI(candid, (response) => {
    if (response.token) {
      managejobapi.checkSubmitStatusAPI(candid, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}

/* Added the following code for POW-793.Dharma using AI Agent. February 27, 2026. Code Start */
/**
 * Validates whether the candidate's resume contains the required skills before PR Submit.
 * Calls the backend /api/job/validate/resume/skills endpoint.
 */
export function validateResumeSkillsAction(candidateId, jobId, indexId, res) {
  managejobapi.validateResumeSkillsAPI(candidateId, jobId, indexId, (response) => {
    if (response.token) {
      managejobapi.validateResumeSkillsAPI(candidateId, jobId, indexId, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}
/* Code end. Dharma using AI Agent. February 27, 2026 */

/* Added the following code for POW-804.Solomon using AI Agent. June 24, 2026. Code Start */
/**
 * POW-804: Generates AI model updated resume for local save (sir flow — no system upload).
 * POW-964: updateMode — INFERRED | MISSING | BOTH (which skill guidance to apply).
 */
export function aiGenerateResumeAction(candidateId, jobId, indexId, updateMode, additionalPrompt, res) {
  /* Added the following code for POW-964.Harsha using AI Agent. October 21, 2026. Code Start */
  managejobapi.aiGenerateResumeAPI(
    candidateId,
    jobId,
    indexId,
    updateMode,
    additionalPrompt,
    (response) => {
      if (response && response.token) {
        managejobapi.aiGenerateResumeAPI(
          candidateId,
          jobId,
          indexId,
          updateMode,
          additionalPrompt,
          (retryResponse) => {
            return res(retryResponse);
          }
        );
      } else {
        return res(response);
      }
    }
  );
  /* Code end. Harsha using AI Agent. October 21, 2026 */
}
/* Code end. Solomon using AI Agent. June 24, 2026 */

// Save Candidate Note
export function saveCandidateNote(data, res) {
  managejobapi.saveCandidateNoteAPI(data, (response) => {
    // For save operations, we don't expect a token refresh
    // Just pass the response directly to the callback
    return res(response);
  });
}

// Get Candidate Note
export function getCandidateNote(data, res) {
  managejobapi.getCandidateNoteAPI(data, (response) => {
    // For get operations, we don't expect a token refresh
    // Just pass the response directly to the callback
    return res(response);
  });
}

/* Added the following code for POW-864.Dharma using AI Agent. June 27, 2026. Code Start */
export function getVitelglobalRecordings(data, res) {
  managejobapi.getVitelglobalRecordingsAPI(data, (response) => {
    return res(response);
  });
}
/* Code end. Dharma using AI Agent. June 27, 2026 */

/* Added the following code for POW-779.Dharma using AI Agent. February 28, 2026. Code Start */
export function saveJobNote(data, res) {
  managejobapi.saveJobNoteAPI(data, (response) => {
    return res(response);
  });
}

export function getJobNote(data, res) {
  managejobapi.getJobNoteAPI(data, (response) => {
    return res(response);
  });
}
/* Code end. Dharma using AI Agent. February 28, 2026 */

/* Added the following code for POW-869.Dharma using AI Agent. June 9, 2026. Code Start */
export function updateSubmissionDeadline(data, res) {
  managejobapi.updateSubmissionDeadlineAPI(data, (response) => {
    return res(response);
  });
}
/* Code end. Dharma using AI Agent. June 9, 2026 */

/* Added the following code for No Jira Ticket.Harsha using AI Agent. October 29, 2026. Code Start */
export function getSubmissionDeadline(clientJobId, res) {
  managejobapi.getSubmissionDeadlineAPI(clientJobId, (response) => {
    return res(response);
  });
}
/* Code end. Harsha using AI Agent. October 29, 2026 */

/* Added the following code for POW-885.Dharma using AI Agent. July 2, 2026. Code Start */
export function refreshVmsOtherSubmissions(data, res) {
  managejobapi.refreshVmsOtherSubmissionsAPI(data, (response) => {
    return res(response);
  });
}
/* Code end. Dharma using AI Agent. July 2, 2026 */

// Get Views
export function getViews(res) {
  managejobapi.getViewsAPI((response) => {
    // For get operations, we don't expect a token refresh
    // Just pass the response directly to the callback
    return res(response);
  });
}

/* Added the following code for POW-811.Harsha using AI Agent. May 19, 2026. Code Start */
export function hideCheck(res) {
  managejobapi.hideCheckAPI((response) => {
    return res(response);
  });
}

export function hideCandidate(data, res) {
  managejobapi.hideCandidateAPI(data, (response) => {
    if (response.token) {
      managejobapi.hideCandidateAPI(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}

export function hideJob(data, res) {
  managejobapi.hideJobAPI(data, (response) => {
    if (response.token) {
      managejobapi.hideJobAPI(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}
/* Code end. Harsha using AI Agent. May 19, 2026 */

/* Added the following code for POW-CLIENT-SUBMIT.Istiyak using AI Agent. June 5, 2026. Code Start */
export function clientSubmitAction(data, res) {
  managejobapi.clientSubmitAPI(data, (response) => {
    if (response.token) {
      managejobapi.clientSubmitAPI(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}

export function clientSubmitStatusAction(data, res) {
  managejobapi.clientSubmitStatusAPI(data, (response) => {
    if (response.token) {
      managejobapi.clientSubmitStatusAPI(data, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}
/* Code end. Istiyak using AI Agent. June 5, 2026 */

// Get Candidates for a Job
export function getJobCandidates(jobId, res) {
  managejobapi.getJobCandidatesAPI(jobId, (response) => {
    if (response.token) {
      managejobapi.getJobCandidatesAPI(jobId, (response) => {
        return res(response);
      });
    } else {
      return res(response);
    }
  });
}